var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
require( "../../src/js/lib/masonry.js" );

function Footer(el) {
  // var t = this;
  // use "load" event because height is calculated wrong on load
  // setTimeout(function() {
  //   t.$el = $(el);
  //   t.$menu = t.$el.find('.js-footer-menu');
  //   if (t.$menu) {
  //     t.$menu.masonry();
  //
  //     $(window).on('resize', function () {
  //       t.$menu.masonry();
  //     });
  //   }
  // }, 500);
}

module.exports = Footer;
